import { OnlinePagesFontTypeEnum, OnlinePagesFontWeightEnum } from './types';

export const getFontTypeRaw = (type: OnlinePagesFontTypeEnum) =>
    type.replace(/\(.*\)/, '').trim();

export const getFontLetterform = (
    type: OnlinePagesFontTypeEnum
): 'sans-serif' | 'serif' | 'cursive' | 'monospace' | undefined => {
    const letterform = /\((.*)\)/.exec(type)?.[1];

    switch (letterform) {
        case 'display':
        case 'handwriting':
            return 'cursive';
        case 'sans-serif':
        case 'serif':
        case 'monospace':
        case 'cursive':
            return letterform;
        default:
            return undefined;
    }
};

export const getFontFamily = (type: OnlinePagesFontTypeEnum) => {
    let font = `'${getFontTypeRaw(type)}'`;
    const letterform = getFontLetterform(type);
    if (letterform) {
        font += `, ${letterform}`;
    }
    return font;
};

export const getFontGoogleUrl = (
    type: OnlinePagesFontTypeEnum,
    weight: OnlinePagesFontWeightEnum
) => `${getFontTypeRaw(type).replace(/ /g, '+')}:wght@${weight}`;
